import { jsx as o } from "react/jsx-runtime";
import { ai as e } from "../../vendor-CPVnY93G.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as t } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index38.css';const i = "_fieldError_taatg_1", f = {
  fieldError: i
};
function d(r) {
  return r.children ? /* @__PURE__ */ o(
    e,
    {
      ...t(r),
      className: f.fieldError,
      "data-component": "FieldError"
    }
  ) : null;
}
export {
  d as FieldError
};
